
export const EMOJI = {
    SAD: '😟',
    INVALID: '⛔️'
}
